import { frontendURL } from 'dashboard/helper/URLHelper';
import PipelineBoard from './PipelineBoard.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/pipeline'),
    name: 'pipeline_board',
    component: PipelineBoard,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
